<template>
  <transition name="slide-fade">
    <div v-if="showBasket" class="basket" @click.stop.prevent="handleClick">
      <div class="basket__container" @click.stop="doNothing">
        <h2 class="basket__title">Basket</h2>
        <div class="basket__icon" @click.stop.prevent="handleClick">
          <font-awesome-icon :icon="['fal', 'times']" class="fa fa-stack-1x right" />
        </div>
      </div>
      <section class="basket__content" @click.stop="doNothing">
        <div class="basket__panel">
          <transition name="fade">
            <div v-if="!getNumOfItems" class="basket__empty">
              <p class="basket__empty-heading">Is everything okay?</p>
              <p class="basket__empty-text">Your cart is empty</p>
              <a :href="`${$config.baseURL}/best-selling-magazine-subscriptions`" class="basket__empty-button" target="" @click.prevent="handleClickBestSelling()">
                Shop Best Selling
              </a>
            </div>
          </transition>
          <!-- <transition-group name="fade"> -->
          <BasketProduct v-for="item in basketItems" :key="`${item.id}`" :price="item.offer.price" :qty="item.offer.qty" :save="item.offer.save" :item="mapItem(item)" />
          <!-- </transition-group> -->
        </div>
      </section>

      <BasketTotals v-if="getNumOfItems" class="basket__bottom" />

      <client-only>
        <div class="basket__content ways_to_pay__container">
          <WaysToPay v-if="getNumOfItems" />
        </div>
      </client-only>

      <section v-if="upsell?.length && getNumOfItems" class="basket__upsell" @click.stop="doNothing">
        <div class="basket__panel">
          <p class="basket__upsell-heading">Why not try one of our other top sellers...</p>
        </div>

        <div>
          <transition-group name="card" class="basket__panel upsell-grid items-list">
            <UpsellProduct
              v-for="item in upsell"
              :key="`${item.id}`"
              :type="'upsell'"
              :item="mapItem(item)"
              class="basket__upsell-item items-list__item"
              imgix-query-string="&w=130"
            />
          </transition-group>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapAPIIBasketItemToLegacy } from '~/lib/util/basket'
import { createPathOrURLWithQueryParam } from '~/lib/util/page'

export default {
  name: 'Basket',
  serverCacheKey() {
    return false
  },
  components: {
    UpsellProduct: () => import('~/components/common/list/Product.vue'),
    BasketProduct: () => import('~/components/common/basket/Product.vue'),
    BasketTotals: () => import('~/components/common/Totals.vue'),
    WaysToPay: () => import('~/components/common/WaysToPay.vue')
  },
  props: {
    showBasket: {
      type: Boolean,
      required: true,
      default() {
        return false
      }
    },
    cart: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      upsell: 'basket/upsell',
      basket: 'basket/payload',
      num_of_items: 'basket/num_of_items'
    }),
    basketItems() {
      if (this?.basket?.items && this?.basket?.items[0]?.id === null) {
        console.log('basketItems & BASKET with errors')
        return []
      }

      console.log('BasketItems MongoDB=', this.basket.items)
      // Aggregate Each BasketItem by item.sku and offer.sku and update the qty
      const aggregatedItems = []
      const aggregatedIndex = []
      let index = 0
      this.basket.items.forEach(item => {
        const itemSku = item.sku
        const offerSku = item.offer.sku
        const itemId = item.id
        let key = `${itemSku}_${offerSku}`
        if (item.type === 'GIFTCARD' || item.type === 'EGIFTCARD' || item.type === 'POCKETMAGSPLUS') {
          key = `${itemId}`
        }
        if (aggregatedIndex[key] >= 0) {
          // Item with the same sku and offer sku already exists, add to the quantity
          const i = aggregatedIndex[key]
          aggregatedItems[i].qty += 1
          // console.log(`UPDATED aggregatedIndex key=${i} aggregatedIndex[key]=${aggregatedIndex[i]} item=`, aggregatedItems[i])
        } else {
          aggregatedIndex[key] = index
          // Create a new aggregated item entry
          aggregatedItems[index] = {
            ...item,
            qty: 1
          }
          // console.log(`ADDED aggregatedIndex key=${index} aggregatedIndex[key]=${aggregatedIndex[key]} item=`, aggregatedItems[index])
          index++
        }
      })
      console.log('BasketItems Aggregated MongoDB=', aggregatedItems)
      return aggregatedItems || []
    },
    getNumOfItems() {
      return this.$store.state.basket.num_of_items || 0 // MONGODB NUM_OF_ITEMS
    }
  },

  methods: {
    handleClick() {
      console.log('Basket handleClick CLOSE')
      this.$nuxt.$emit('SHOW_BASKET', false)
    },
    doNothing() {
      console.log('Basket doNothing')
    },
    mapItem(item) {
      return mapAPIIBasketItemToLegacy(item)
    },
    handleClickBestSelling() {
      window.location.href = createPathOrURLWithQueryParam({ pathOrURL: '/best-selling-magazine-subscriptions', query: this.$route.query })
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.card {
  transition: all 0.5s;
}
.card-enter, .card-leave-to
/* .card-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: scale(0);
}
.card-enter-to {
  opacity: 1;
  transform: scale(1);
}

.card-leave-active {
  position: absolute;
}

.card-move {
  opacity: 1;
  transition: all 0.5s;
}

.basket {
  overflow: auto;
  max-height: 100vh;
  position: fixed;
  z-index: 2147483647;
  top: 0;
  left: 0;
  visibility: visible;
  width: 100%;
  height: 100%;
  -webkit-transition: opacity 250ms ease-in-out, visibility 250ms ease-in-out;
  transition: opacity 250ms ease-in-out, visibility 250ms ease-in-out;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.7);
  &__container {
    z-index: 100;
    transform: none;
    width: 400px;
    height: 65px;
    line-height: 65px;
    border-bottom: 1px solid #000;
    float: right;
    position: relative;
    clear: both;
    background-color: #fff;
    text-align: center;
  }
  &__title {
    float: left;
    padding: 0 20px;
    padding: 0 20px;
    font-size: 16px;
    text-align: left;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #000;
    line-height: unset;
  }
  &__icon {
    float: right;
    vertical-align: middle;
    &:hover {
      cursor: pointer;
    }
    .right {
      box-sizing: content-box;
      position: relative;
      vertical-align: middle;
      padding: 0 20px;
      height: 1.5em;
      width: 1.5em;
    }
  }
  &__content,
  &__bottom,
  &__upsell {
    padding-top: 10px;
    z-index: 100;
    transform: none;
    width: 400px;
    height: auto;
    float: right;
    position: relative;
    clear: both;
    background-color: #fff;
    text-align: center;
  }
  &__empty {
    margin: 40px 0;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  &__empty-heading {
    margin: 0 0 10px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    font-weight: 700;
  }
  &__empty-button {
    width: 50%;
    min-width: 300px;
    margin: 10px 4%;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    background-color: $prodcutOfferColor;
    display: block;
    height: 40px;
    font-size: 13px;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    border-radius: 0;
  }
  &__empty-button:hover {
    opacity: 0.7;
    filter: alpha(opacity=70);
    color: #fff;
  }
  &__upsell-heading {
    margin: 0 0 10px;
    letter-spacing: 0.1em;
    font-weight: 700;
    padding: 0 10%;
  }

  .upsell-grid {
    .items-list {
      &__item {
        padding: 0px 20px;
        margin: 10px;
        flex: 1 0 30%;
        max-width: 170px;
        min-width: 100px;
        .actions button {
          background-color: transparent;
          text-align: center;
          font-size: 12px;
          color: $buttonAddToCartColor;
          line-height: 12px;
          margin: 0em;
          text-decoration: underline;
          min-width: 100px;
          padding: 10px 0px;
          &:hover {
            text-decoration: none;
          }
          .spinner {
            top: 40%;
          }
        }
        .view-btn {
          display: none;
        }
        .btn-divider {
          display: none;
        }
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
@media (max-width: $screen-xs-max) {
  .basket {
    overflow: auto;
    max-height: 100vh;

    &__container {
      min-width: 80%;
      max-width: 80%;
    }
    &__content,
    &__bottom,
    &__upsell {
      min-width: 80%;
      max-width: 80%;
    }
    .upsell-grid {
      .items-list {
        &__item {
          margin: 10px;
          flex: 1 0 30%;
          max-width: 170px;
          min-width: 100px;
          padding: unset;
          img {
            max-width: 100px;
          }
        }
      }
      margin-bottom: 40px;
    }

    &__empty-button {
      width: 40%;
      min-width: 200px;
    }
  }
  .basket__icon .right {
    box-sizing: content-box;
    padding: 0 20px;
  }
  .basket__bottom {
    padding-bottom: 0 !important;
  }
}
@media (max-width: 320px) {
  .basket {
    overflow: auto;
    max-height: 100vh;

    &__container {
      min-width: 100%;
      max-width: 100%;
      max-width: 320px;
    }
    &__content,
    &__bottom,
    &__upsell {
      min-width: 100%;
      max-width: 100%;
      max-width: 320px;
    }
    .upsell-grid {
      .items-list {
        &__item {
          flex: 0 0 30%;
        }
      }
      margin-bottom: 40px;
    }

    &__empty-button {
      width: 40%;
      min-width: 200px;
    }
  }
  .basket__icon .right {
    box-sizing: content-box;
    padding: 0 20px;
  }
}

/* ==========================================================================
    Internet Explorer Section
   ========================================================================== */
/*  IE10+ */
@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
  .upsell-grid {
    .items-list {
      justify-content: space-around;
    }
  }
}
.ways_to_pay__container {
  display: block;
  z-index: 100;
  float: right;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  padding: 0 !important;
}

/* iPhone 14 Pro Max - 1284×2778 pixels at 460ppi */
@media only screen and (max-device-width: 430px) and (max-device-height: 932px) and (-webkit-device-pixel-ratio: 3) {
  .basket {
    .items-list__item {
      min-height: 265px !important;
    }
  }
}
</style>
